import { Component, OnInit, ViewChild } from '@angular/core';
import { BreadcrumbComponent } from '../../Common/Components/breadcrumb/breadcrumb.component';
import { SpinnerComponent } from '../../Common/Components/spinner/spinner.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FormsModule } from '@angular/forms';
import { DataGridComponent } from '../../Common/Components/data-grid/data-grid.component';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { AddAmdJobAllocateComponent } from "./add-amd-job-allocate/add-amd-job-allocate.component";
import { ApiService } from '../../Services/api.service';
import { NzInputModule } from 'ng-zorro-antd/input';
import { ConfirmPopupComponent } from '../../Common/Components/confirm-popup/confirm-popup.component';

@Component({
  selector: 'app-amd-job-code-allocate',
  standalone: true,
  imports: [ SpinnerComponent, NzButtonModule, ConfirmPopupComponent, NzInputModule, NzDrawerModule, RouterModule, CommonModule, FormsModule, DataGridComponent, NzIconModule, NzSelectModule, AddAmdJobAllocateComponent],
  templateUrl: './amd-job-code-allocate.component.html',
  styleUrl: './amd-job-code-allocate.component.scss'
})
export class AmdJobCodeAllocateComponent implements OnInit {

  constructor(private apiService: ApiService) {

  }
  viewEditForm: string = '';
  isLoading: boolean = false;
  linkDrawer: boolean = false;
  selectedProgram: any;
  selectedLocation: any;
  invalidSearch: boolean = false;
  programList: any = [];
  locationList: any = [];
  amdArrData: any = [];
  selectedAmdJobLoc: any = [];
  amdColumns = [
    {
      field: 'jobCode',
      header: '',
      type: "checkbox"
    },
    {
      field: 'jobCode',
      header: 'Job Code',
      compare: (a: any, b: any) => (a.jobCode ?? "").localeCompare((b.jobCode ?? ""))
    },
    {
      field: 'locationCode',
      header: 'Location Code',
      compare: (a: any, b: any) => (a.locationCode ?? "").localeCompare((b.locationCode ?? ""))
    },
    {
      field: '',
      header: 'Action',
      icons: ['delete'],
      type: 'icon',
      showIcons: true
    }];
  toggledRows: any = [];
  payLoadData: any = [];
  @ViewChild(DataGridComponent) private dataGridComponent!: DataGridComponent;
  searchText: string = '';
  showModal: boolean = false;


  ngOnInit(): void {
    this.apiService.getProgramCode().subscribe(res => {
      this.programList = res['data'];
    })
  }

  getLocationList() {
    if (this.selectedLocation) {
      this.selectedLocation = '';
    }
    this.apiService.getLocationCode(this.selectedProgram).subscribe(res => {
      this.locationList = res;
    })
  }

  searchJobLocationCode() {
    if (!this.selectedLocation || !this.selectedProgram) {
      this.invalidSearch = true;
      return
    }
    this.invalidSearch = false;
    this.isLoading = true;
    this.apiService.getLocationJobCode(this.selectedLocation).subscribe(res => {
      this.amdArrData = res.data;
      this.isLoading = false;
      if (this.selectedProgram == 'AMD ALLOW') {
        const existingIndex = this.amdColumns.findIndex(node => node.field == 'dispCustomFields');

        if (existingIndex === -1) {
          const Obj = {
            field: 'dispCustomFields',
            header: 'Display Custom Fields',
            type: "toggle",
            icons: [],
            showIcons: false
          };
          this.amdColumns.splice(3, 0, Obj);
          this.amdColumns = [...this.amdColumns];
        }
      }
      else {
        const targetIndex = this.amdColumns.findIndex(node => node.field == 'dispCustomFields');

        if (targetIndex !== -1) {
          this.amdColumns.splice(targetIndex, 1);
          this.amdColumns = [...this.amdColumns];
        }
      }
    }, err => {
      this.isLoading = false;
      this.apiService.createNotification('error', err?.error?.message);
    })
  }

  searchLocation(searchValue: string) {
    this.dataGridComponent.searchData(searchValue, 'jobCode');
  }

  deleteRow(event: any) {
    const deleteObj = {
      "locationCode": event.locationCode,
      "jobCode": event.jobCode,
      "description": event.description,
      "dispCustomFields": event.dispCustomFields,
      "updateType": "DELETE"
    };
    this.updateJobLocCode([deleteObj])
  }

  updateJobLocCode(data: any) {
    this.apiService.updateJobLocCode(data).subscribe(res => {
      this.apiService.createNotification('success', res?.message);
      this.payLoadData = [];
      this.showModal = false;
      if (this.selectedLocation && this.selectedProgram)
        this.searchJobLocationCode();
    }, err => {
      this.apiService.createNotification('error', err?.error?.message);
    })
  }

  selectedRows(data: any) {
    this.selectedAmdJobLoc = [...data];
  }

  addRow(data: any) {
    this.linkDrawer = false;
    this.updateJobLocCode(data);
  }

  deleteSelected() {
    const deleteArr: any = [];
    this.selectedAmdJobLoc.map((res1: any) => {
      this.amdArrData.map((res2: any) => {
        if (res1 == res2.jobCode) {
          deleteArr.push({
            "locationCode": res2.locationCode,
            "jobCode": res2.jobCode,
            "description": res2.description,
            "dispCustomFields": res2.dispCustomFields,
            "updateType": "DELETE"
          })
        }
      })
    });
    this.payLoadData = deleteArr;
    this.showModal = true;
  }

  toggledRow(event: any) {
    if (this.toggledRows.length == 0 || !this.toggledRows.find((node: any) => node.jobCode == event.jobCode)) {
      const updateObj = {
        "locationCode": event.locationCode,
        "jobCode": event.jobCode,
        "description": event.description,
        "dispCustomFields": event.dispCustomFields,
        "updateType": "UPDATE"
      };
      this.toggledRows.push(updateObj);
    }
    else {
      const existEleIndex = this.toggledRows.findIndex((node: any) => node.jobCode === event.jobCode);
      this.toggledRows[existEleIndex]["dispCustomFields"] = event.dispCustomFields;
    }
  }
}
